import React from 'react'

const ProjectText = ({ item }) => {
	return <div></div>
}

export default ProjectText
